export const LevelOfServiceColors = [
  { value: 0, color: '#730b0b' },
  { value: 1, color: '#a90000' },
  { value: 2, color: '#b15a00' },
  { value: 3, color: '#5f9438' },
];
